<script>
import { defineComponent, watchEffect } from "@vue/composition-api";
import SearchForm from "./SearchForm.vue";
import Table from "./Table.vue";
import EmailDrawer from "./EmailDrawer.vue";
import useState from "./use-state";

export default defineComponent({
  name: "EmailManage",
  components: { SearchForm, Table, EmailDrawer },
  setup(_, { refs }) {
    const { dataSource, getTableDataSource } = useState();

    const handleSearchForm = (val) => {
      getTableDataSource(val.value.emailName);
    };

    // 新建邮件
    const handleCreateProject = () => {
      refs.emailDrawerRef.openModal();
    };

    // 编辑邮件
    const handleModifyMailbox = (val) => {
      refs.emailDrawerRef.openModal(val);
    };

    watchEffect(() => getTableDataSource());

    return {
      dataSource,
      getTableDataSource,
      handleSearchForm,
      handleCreateProject,
      handleModifyMailbox,
    };
  },
});
</script>

<template>
  <div class="email-manage">
    <div class="email-manage__header">
      <SearchForm @on-search-form="handleSearchForm" />
      <a-button type="primary" @click="handleCreateProject">新建项目</a-button>
    </div>
    <div class="email-manage__content">
      <Table :data-source="dataSource" @on-modify-mailbox="handleModifyMailbox" />
    </div>
    <EmailDrawer
      ref="emailDrawerRef"
      :created-email="dataSource"
      @on-refresh-table="getTableDataSource"
    />
  </div>
</template>

<style lang="less" scoped>
.email-manage {
  &__header {
    width: 100%;
    height: 80px;
    background: #fff;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 20px 0 38px;
    border-radius: 6px;
  }

  &__content {
    background: #fff;
    border-radius: 6px;
    margin-top: 16px;
    padding: 24px 28px;
  }
}
</style>
